import { BRAND_GGT, BRAND_GGV } from "./brands";

const GGV_BASE_PATH = `/${BRAND_GGV}`;
const GGV_SCHEDULE_PATH = `${GGV_BASE_PATH}/schedule`;

const GGT_BASE_PATH = `/${BRAND_GGT}`;
const GGT_SCHEDULE_PATH = `${GGT_BASE_PATH}/schedule`;

const VAXYES_BASE_PATH = `/vaxyes`;

const ROUTE_PATHS = {
  GGV: {
    SCHEDULE_BASE: GGV_SCHEDULE_PATH,
    SCHEDULE_START: `${GGV_SCHEDULE_PATH}/start`,
    SCHEDULE_START_WITH_TOKEN: `${GGV_SCHEDULE_PATH}/startwt`
  },
  GGT: {
    SCHEDULE_BASE: GGT_SCHEDULE_PATH,
    SCHEDULE_START: `${GGT_SCHEDULE_PATH}/start`
  },
  VAXYES: {
    REGISTER_BASE: `${VAXYES_BASE_PATH}/register`,
    VERIFY: `${VAXYES_BASE_PATH}/verify`,
    REGISTER_BASE_BOOSTER: `${VAXYES_BASE_PATH}/booster`
  }
};

export { ROUTE_PATHS };
